import useNetwork from '../../hooks/useNetwork';

export default function useNetworkFilter() {
  const network = useNetwork();

  return {
    networkId: network?.id
  };
};
